import React, { ReactElement } from 'react';

export default function Exclamation (props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='12' cy='12' r='9.5' stroke='currentColor' />
            <rect fill='currentColor' height='8' rx='0.5' width='1' x='11.5' y='6' />
            <circle cx='12' cy='17' fill='currentColor' r='1' />
        </svg>
    );
}

